document.addEventListener('DOMContentLoaded', function () {
  const filterBar = document.getElementById('stvs-filter-bar');
  if (!filterBar) return;

  const container = document.getElementById('stvs-store-wp-plugin-container');
  if (!container) return;

  // -------------------------------------------------------------------------
  // STATE
  // Keys match the Typesense field mapping below.
  // -------------------------------------------------------------------------
  const filterState = {
    sub_category: [], // toggled by quick-filter buttons
    plan:         '',  // single-select
    event:        [],
    game:         [],
    color:        [],
    style:        [],
  };

  // Maps filterState keys → Typesense field names (mirrors index.vue getFilter())
  const TYPESENSE_FIELDS = {
    sub_category: 'categories',
    plan:         'plan',
    event:        'events',
    game:         'games',
    color:        'colors',
    style:        'styles',
  };

  // -------------------------------------------------------------------------
  // FILTER_BY BUILDER
  // The base filter_by from the shortcode attribute is always prepended so
  // the shortcode's own constraints (skuable_type, ai_generated, etc.) are
  // preserved alongside the user's selections.
  // -------------------------------------------------------------------------
  function buildFilterBy() {
    const parts = [];

    for (const [key, field] of Object.entries(TYPESENSE_FIELDS)) {
      const val = filterState[key];
      if (Array.isArray(val) && val.length) {
        parts.push(`${field}:=[${val.join(',')}]`);
      } else if (typeof val === 'string' && val) {
        parts.push(`${field}:=[${val}]`);
      }
    }

    const baseFilter = container.dataset.filterBy || '';
    const userFilter = parts.join(' && ');
    return [baseFilter, userFilter].filter(Boolean).join(' && ');
  }

  // -------------------------------------------------------------------------
  // APPLY – dispatch event that grid.js listens for
  // -------------------------------------------------------------------------
  function applyFilters() {
    container.dispatchEvent(
      new CustomEvent('stvs:filter-change', {
        detail: { filter_by: buildFilterBy() },
      })
    );
    updateUI();
  }

  // -------------------------------------------------------------------------
  // QUICK-FILTER BUTTONS (sub-category row)
  // -------------------------------------------------------------------------
  filterBar.querySelectorAll('.stvs-filter-quick-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const value = btn.dataset.filterValue;
      const idx = filterState.sub_category.indexOf(value);
      if (idx === -1) {
        filterState.sub_category.push(value);
      } else {
        filterState.sub_category.splice(idx, 1);
      }
      applyFilters();
    });
  });

  // -------------------------------------------------------------------------
  // DROPDOWN – open / close / select / clear
  // -------------------------------------------------------------------------
  let openDropdown = null;

  function closeAllDropdowns() {
    filterBar.querySelectorAll('.stvs-filter-dropdown-panel').forEach(function (p) {
      p.classList.add('stvs-hidden');
    });
    filterBar.querySelectorAll('.stvs-filter-caret').forEach(function (c) {
      c.style.transform = '';
    });
    openDropdown = null;
  }

  filterBar.addEventListener('click', function (e) {
    // Toggle dropdown open/close
    const toggleBtn = e.target.closest('[data-dropdown-toggle]');
    if (toggleBtn) {
      e.stopPropagation();
      const type    = toggleBtn.dataset.dropdownToggle;
      const wrapper = toggleBtn.closest('.stvs-filter-dropdown-wrapper');
      const panel   = wrapper.querySelector('.stvs-filter-dropdown-panel');
      const caret   = toggleBtn.querySelector('.stvs-filter-caret');

      if (openDropdown === type) {
        closeAllDropdowns();
      } else {
        closeAllDropdowns();
        panel.classList.remove('stvs-hidden');
        if (caret) caret.style.transform = 'rotate(180deg)';
        openDropdown = type;
      }
      return;
    }

    // Clear a single dropdown's selection
    const clearBtn = e.target.closest('[data-dropdown-clear]');
    if (clearBtn) {
      e.stopPropagation();
      const type = clearBtn.dataset.dropdownClear;
      resetDropdown(type);
      applyFilters();
      return;
    }

    // Select / deselect a dropdown item
    const itemEl = e.target.closest('[data-item-type]');
    if (itemEl) {
      const type    = itemEl.dataset.itemType;
      const value   = itemEl.dataset.itemValue;
      const wrapper = itemEl.closest('.stvs-filter-dropdown-wrapper');
      const isMulti = wrapper.dataset.multi === 'true';

      if (isMulti) {
        const arr = filterState[type];
        const idx = arr.indexOf(value);
        if (idx === -1) arr.push(value); else arr.splice(idx, 1);
      } else {
        // Single-select: toggle (click same item again to deselect)
        filterState[type] = filterState[type] === value ? '' : value;
        closeAllDropdowns();
      }

      applyFilters();
      return;
    }

    // Clear all filters
    if (e.target.closest('#stvs-filter-clear-all')) {
      clearAllFilters();
      return;
    }
  });

  // Close dropdowns on outside click
  document.addEventListener('click', function (e) {
    if (!filterBar.contains(e.target)) closeAllDropdowns();
  });

  function resetDropdown(type) {
    filterState[type] = Array.isArray(filterState[type]) ? [] : '';
    closeAllDropdowns();
  }

  function clearAllFilters() {
    for (const key in filterState) {
      filterState[key] = Array.isArray(filterState[key]) ? [] : '';
    }
    applyFilters();
  }

  // -------------------------------------------------------------------------
  // SCROLL ARROWS for the quick-filter row
  // -------------------------------------------------------------------------
  const scrollContainer = document.getElementById('stvs-filter-scroll-container');
  const scrollInner     = document.getElementById('stvs-filter-scroll-inner');
  const arrowLeft       = document.getElementById('stvs-filter-arrow-left');
  const arrowRight      = document.getElementById('stvs-filter-arrow-right');
  const scrollLeftBtn   = document.getElementById('stvs-filter-scroll-left');
  const scrollRightBtn  = document.getElementById('stvs-filter-scroll-right');

  function updateScrollArrows() {
    if (!scrollContainer || !scrollInner) return;

    const cw = scrollContainer.clientWidth;
    const sw = scrollInner.scrollWidth;
    const sl = scrollInner.scrollLeft;

    if (cw >= sw) {
      arrowLeft  && arrowLeft.classList.add('stvs-hidden');
      arrowRight && arrowRight.classList.add('stvs-hidden');
      return;
    }

    if (arrowLeft)  arrowLeft.classList.toggle('stvs-hidden',  sl <= 1);
    if (arrowRight) arrowRight.classList.toggle('stvs-hidden', sw - cw - sl <= 1);
  }

  scrollLeftBtn  && scrollLeftBtn.addEventListener('click',  function () { scrollInner.scrollBy({ left: -180, behavior: 'smooth' }); });
  scrollRightBtn && scrollRightBtn.addEventListener('click', function () { scrollInner.scrollBy({ left:  180, behavior: 'smooth' }); });
  scrollInner    && scrollInner.addEventListener('scroll', updateScrollArrows);
  window.addEventListener('resize', updateScrollArrows);
  updateScrollArrows();

  // -------------------------------------------------------------------------
  // UI UPDATE – visual sync of buttons / dropdowns / badge with filterState
  // -------------------------------------------------------------------------
  function slugToLabel(slug) {
    return slug.replace(/[-_]/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
  }

  function updateUI() {
    let activeCount = 0;

    // Quick-filter buttons
    filterBar.querySelectorAll('.stvs-filter-quick-btn').forEach(function (btn) {
      const active = filterState.sub_category.includes(btn.dataset.filterValue);
      btn.style.backgroundColor = active ? 'rgba(255,255,255,0.12)' : '';
      btn.style.color            = active ? '#ffffff' : '';
      btn.style.borderColor      = active ? 'rgba(255,255,255,0.2)' : '';
      if (active) activeCount++;
    });

    // Dropdown wrappers
    filterBar.querySelectorAll('.stvs-filter-dropdown-wrapper').forEach(function (wrapper) {
      const type         = wrapper.dataset.dropdownType;
      const isMulti      = wrapper.dataset.multi === 'true';
      const defaultLabel = wrapper.dataset.defaultLabel;
      const val          = filterState[type];
      const count        = isMulti ? (Array.isArray(val) ? val.length : 0) : (val ? 1 : 0);

      const mainBtn  = wrapper.querySelector('.stvs-filter-dropdown-btn');
      const labelEl  = wrapper.querySelector('.stvs-filter-dropdown-label');
      const countEl  = wrapper.querySelector('.stvs-filter-dropdown-count');
      const clearBtn = wrapper.querySelector('.stvs-filter-dropdown-clear');

      // Active / inactive button styles
      if (count > 0) {
        mainBtn.style.color       = '#ffffff';
        mainBtn.style.borderColor = 'rgba(255,255,255,0.2)';
        mainBtn.classList.add('stvs-rounded-r-none');
        clearBtn.classList.remove('stvs-hidden');
        activeCount += count;
      } else {
        mainBtn.style.color       = '';
        mainBtn.style.borderColor = '';
        mainBtn.classList.remove('stvs-rounded-r-none');
        clearBtn.classList.add('stvs-hidden');
      }

      // Label text
      if (isMulti) {
        if (count === 1) {
          labelEl.textContent = slugToLabel(val[0]);
        } else {
          labelEl.textContent = defaultLabel;
        }
      } else {
        labelEl.textContent = val ? slugToLabel(val) : defaultLabel;
      }

      // Count badge (multi, >1 selected)
      if (isMulti && count > 1) {
        countEl.textContent = '(' + count + ')';
        countEl.classList.remove('stvs-hidden');
      } else {
        countEl.classList.add('stvs-hidden');
      }

      // Per-item indicators (checkbox / radio)
      wrapper.querySelectorAll('.stvs-filter-dropdown-item').forEach(function (item) {
        const itemValue = item.dataset.itemValue;
        const isActive  = isMulti
          ? Array.isArray(val) && val.includes(itemValue)
          : val === itemValue;

        const indicator = item.querySelector('.stvs-filter-item-indicator');
        const checkIcon = item.querySelector('.fa-check');
        const radioDot  = item.querySelector('.stvs-filter-radio-dot');

        if (indicator) indicator.style.backgroundColor = isActive ? '#f97316' : '';
        if (checkIcon) checkIcon.classList.toggle('stvs-hidden', !isActive);
        if (radioDot)  radioDot.classList.toggle('stvs-hidden',  !isActive);
      });
    });

    // Global filter badge
    const badge = document.getElementById('stvs-filter-badge');
    if (badge) {
      badge.textContent = activeCount > 0 ? activeCount : '';
      badge.classList.toggle('stvs-hidden', activeCount === 0);
    }

    // "Clear all" link
    const clearAllBtn = document.getElementById('stvs-filter-clear-all');
    if (clearAllBtn) clearAllBtn.classList.toggle('stvs-hidden', activeCount === 0);
  }
});
